import React, { useState } from 'react';
import { IOrder } from '@/interfaces/order';
import OrderViewInfo from './order-view-info';
import OrderEditInfo from './order-edit-info';
import { Col, Divider, Row, StepProps, Steps } from 'antd';
import { getOrderStepStatus, getPodUrl } from '@/helpers/orderHelper';
import { EOrderStatus } from '@/enums/EOrder';
import { EShippingType } from '@/enums/EShippingType';
import { FileDoneOutlined } from '@ant-design/icons';

interface IProps {
  data: IOrder;
  onRefresh: () => void;
  isManual?: boolean;
}

const OrderInfo = ({ data, onRefresh, isManual }: IProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const orderStep = getOrderStepStatus(data.status);
  return (
    <div className="flex flex-col gap-3 w-full">
      {!isManual && (
        <>
          <Row gutter={12}>
            <Col span={24}>
              <Steps
                current={orderStep?.step}
                items={[
                  {
                    title: 'สร้างออเดอร์',
                    description: data.createByName,
                  },
                  {
                    title: 'ยืนยันจัดสินค้า',
                    description:
                      data?.status == EOrderStatus.REJECTED ? (
                        <>
                          <div>{`${data.rejectByName}`}</div>
                          {`[${data.interfaceErrorCode || ''}] ${data.whMessage || ''}`}
                        </>
                      ) : (
                        data.approveByName
                      ),
                    status:
                      data?.isApprove && data?.status != EOrderStatus.REJECTED
                        ? 'finish'
                        : data?.status == EOrderStatus.REJECTED
                          ? 'error'
                          : 'process',
                  },
                  {
                    title: 'Received by Pioneer',
                    description: data.receiveByName,
                    status: data?.receiveByName
                      ? 'finish'
                      : [EOrderStatus.PENDING].includes(data.status)
                        ? 'wait'
                        : 'process',
                  },
                  {
                    title: 'ยืนยันส่งเอกสาร',
                    description: data.confirmByName,
                    status: data.isConfirm ? 'finish' : 'wait',
                  },
                  {
                    title:
                      data.status === EOrderStatus.CANCEL
                        ? 'ยกเลิกออเดอร์'
                        : data?.transportation === EShippingType.PUIS
                          ? 'สำเร็จ'
                          : 'Dispatched',
                    description:
                      data.status === EOrderStatus.CANCEL
                        ? `${data?.deleteByName} - ${data?.deleteRemark}`
                        : data?.completeByName,
                    status:
                      data.status === EOrderStatus.RECEIVED
                        ? 'process'
                        : [
                              EOrderStatus.PENDING,
                              EOrderStatus.APPROVED,
                              EOrderStatus.REJECTED,
                            ].includes(data.status)
                          ? 'wait'
                          : 'finish',
                  },
                  {
                    title: 'POD',
                    description: (
                      <div className="text-green-600">
                        {data.podByName && `${data.podByName} - `}
                        {data?.podLink && (
                          <a
                            href={getPodUrl(data.podLink)}
                            target="_blank"
                            className="underline text-green-700 cursor-pointer"
                            rel="noreferrer"
                          >
                            <FileDoneOutlined /> เอกสารขนส่ง
                          </a>
                        )}
                      </div>
                    ),
                    status:
                      data?.transportation === EShippingType.TRUCK &&
                      data.status === EOrderStatus.COMPLETED
                        ? 'process'
                        : !data.isPod
                          ? 'wait'
                          : 'finish',
                  },
                  data?.isReturn
                    ? {
                        title:
                          data.status === EOrderStatus.PARTIAL_RETURN
                            ? 'Partial Return Order'
                            : 'Return Order',
                        description: (
                          <div className="text-red-600 flex flex-row gap-1 text-xs">
                            {data?.returnByName}
                            <a
                              href={`/cndn-note/${data.cndnId}`}
                              target="_blank"
                              className="underline text-red-700 cursor-pointer"
                              rel="noreferrer"
                            >
                              ({data?.cndnCode})
                            </a>
                          </div>
                        ),
                        status: 'error',
                      }
                    : ({} as StepProps),
                ]}
              />
            </Col>
          </Row>
          <Divider className="m-0" />
        </>
      )}

      {!isEdit ? (
        <OrderViewInfo
          data={data}
          onEdit={() => setIsEdit(true)}
          onRefresh={() => onRefresh()}
          isManual={isManual}
        />
      ) : (
        <OrderEditInfo
          data={data}
          onEdit={() => {
            setIsEdit(false);
            onRefresh();
          }}
          isManual={isManual}
        />
      )}
    </div>
  );
};

export default OrderInfo;
